module.exports = __webpack_public_path__ + "static/coworking-69a9407b2658a87b2b3d625b68927e29.png";